import {
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
} from '@ionic/react';
import { ReactElement } from 'react';
import i18n from '../../../i18n';

export interface ActiveFilterPopoverContentProps {
  showActive: boolean;
  onActiveChange: (active: boolean) => void;
}

export const ActiveFilterPopoverContent = (
  props: ActiveFilterPopoverContentProps
): ReactElement => {
  const { showActive, onActiveChange } = props;
  {
    const onRadioChange = (e: CustomEvent) => {
      onActiveChange(e.detail.value);
    };

    return (
      <IonList lines="full">
        <IonRadioGroup value={showActive} onIonChange={onRadioChange}>
          <IonItem>
            <IonRadio
              name="active"
              aria-label={i18n.t('common:active')}
              value={true}
            >
              <IonLabel>{i18n.t('common:active')}</IonLabel>
            </IonRadio>
          </IonItem>
          <IonItem lines="none">
            <IonRadio
              name="active"
              aria-label={i18n.t('common:inactive')}
              value={false}
            >
              <IonLabel>{i18n.t('common:inactive')}</IonLabel>
            </IonRadio>
          </IonItem>
        </IonRadioGroup>
      </IonList>
    );
  }
};
